import React from 'react';
import { Link } from 'react-router-dom';
import MatchesLineUp from '../Widgets/Matches/LineUp';
import MatchesGoals from '../Widgets/Matches/Goals';

export default () => (
    <div id="statistics-matches">
        <header className="content-header">
            <h1>
                Statistics
                <small>Matches</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-bar-chart"/> Statistics</li>
                <li className="text-bold"><Link to="/statistics/players">Matches</Link></li>
            </ol>
        </header>
        <section className="content">
            <MatchesLineUp />
            <MatchesGoals />
        </section>
    </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Matches/index.js